"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatedEligibilityAdSetToJSON = exports.ValidatedEligibilityAdSetFromJSONTyped = exports.ValidatedEligibilityAdSetFromJSON = exports.instanceOfValidatedEligibilityAdSet = void 0;
var runtime_1 = require("../runtime");
var AgeRange_1 = require("./AgeRange");
var AssetFormat_1 = require("./AssetFormat");
var Budget1_1 = require("./Budget1");
var Gender_1 = require("./Gender");
var Placement_1 = require("./Placement");
var Platform_1 = require("./Platform");
/**
 * Check if a given object implements the ValidatedEligibilityAdSet interface.
 */
function instanceOfValidatedEligibilityAdSet(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfValidatedEligibilityAdSet = instanceOfValidatedEligibilityAdSet;
function ValidatedEligibilityAdSetFromJSON(json) {
    return ValidatedEligibilityAdSetFromJSONTyped(json, false);
}
exports.ValidatedEligibilityAdSetFromJSON = ValidatedEligibilityAdSetFromJSON;
function ValidatedEligibilityAdSetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'assetFormat': !(0, runtime_1.exists)(json, 'asset_format') ? undefined : (0, AssetFormat_1.AssetFormatFromJSON)(json['asset_format']),
        'budget': !(0, runtime_1.exists)(json, 'budget') ? undefined : (0, Budget1_1.Budget1FromJSON)(json['budget']),
        'estimatedImpressionsMin': !(0, runtime_1.exists)(json, 'estimated_impressions_min') ? undefined : json['estimated_impressions_min'],
        'estimatedImpressionsMax': !(0, runtime_1.exists)(json, 'estimated_impressions_max') ? undefined : json['estimated_impressions_max'],
        'ageRanges': !(0, runtime_1.exists)(json, 'age_ranges') ? undefined : (json['age_ranges'].map(AgeRange_1.AgeRangeFromJSON)),
        'genders': !(0, runtime_1.exists)(json, 'genders') ? undefined : (json['genders'].map(Gender_1.GenderFromJSON)),
        'interests': !(0, runtime_1.exists)(json, 'interests') ? undefined : json['interests'],
        'platforms': !(0, runtime_1.exists)(json, 'platforms') ? undefined : (json['platforms'].map(Platform_1.PlatformFromJSON)),
        'placements': !(0, runtime_1.exists)(json, 'placements') ? undefined : (json['placements'].map(Placement_1.PlacementFromJSON)),
        'errorCodes': !(0, runtime_1.exists)(json, 'error_codes') ? undefined : json['error_codes'],
    };
}
exports.ValidatedEligibilityAdSetFromJSONTyped = ValidatedEligibilityAdSetFromJSONTyped;
function ValidatedEligibilityAdSetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'asset_format': (0, AssetFormat_1.AssetFormatToJSON)(value.assetFormat),
        'budget': (0, Budget1_1.Budget1ToJSON)(value.budget),
        'estimated_impressions_min': value.estimatedImpressionsMin,
        'estimated_impressions_max': value.estimatedImpressionsMax,
        'age_ranges': value.ageRanges === undefined ? undefined : (value.ageRanges.map(AgeRange_1.AgeRangeToJSON)),
        'genders': value.genders === undefined ? undefined : (value.genders.map(Gender_1.GenderToJSON)),
        'interests': value.interests,
        'platforms': value.platforms === undefined ? undefined : (value.platforms.map(Platform_1.PlatformToJSON)),
        'placements': value.placements === undefined ? undefined : (value.placements.map(Placement_1.PlacementToJSON)),
        'error_codes': value.errorCodes,
    };
}
exports.ValidatedEligibilityAdSetToJSON = ValidatedEligibilityAdSetToJSON;
